<div class="policy-sensitive-locations">
  <div class="policy-sensitive-locations-add" *ngIf="(isLoading$ | async) === false">
    <div class="policy-sensitive-locations-add-text">
      <div class="policy-sensitive-locations-add-text-description">
        {{ 'policyPage.config.sensitiveLocationsContent.description' | labelsProvider }}
      </div>
      <div class="policy-sensitive-locations-add-text-count">
        {{ 'policyPage.config.sensitiveLocationsContent.selectedCount' | labelsProvider }}: {{ locationsCount }}/{{
          MAX_LOCATIONS
        }}
      </div>
    </div>
    <div class="policy-sensitive-locations-add-button" *ngIf="editable">
      <button
        class="add-location-button"
        (click)="addLocationClicked()"
        [disabled]="isMaxLocationsReached"
        [ngClass]="{ 'add-location-button-disabled': isMaxLocationsReached }"
      >
        <span>{{ 'policyPage.config.sensitiveLocationsContent.addLocation' | labelsProvider }}</span>
      </button>
    </div>
  </div>
  <div class="divider" *ngIf="(isLoading$ | async) === false"></div>
  <div class="policy-sensitive-locations-table-section" *ngIf="(isLoading$ | async) === false">
    <div class="policy-sensitive-locations-table-section-title">
      {{ 'policyPage.config.sensitiveLocationsContent.locationsList' | labelsProvider }}
    </div>
    <div class="policy-sensitive-locations-table-section-body" *ngIf="(isLoading$ | async) === false">
      <div class="policy-sensitive-locations-table-section-body-search">
        <app-autocomplete-search
          class="policy-sensitive-locations-table-section-body-search-box"
          placeholder="Search..."
          (autocompleteOnChange)="locationSearched($event)"
          [values]="locationsForSearchBox"
          [resetSearchBox$]="resetSearchBoxBehavioralSubject$"
        ></app-autocomplete-search>
      </div>

      <p-table [scrollable]="true" [value]="(locationsCurrentPage$ | async) ?? []" class="main-table">
        <ng-template pTemplate="header">
          <tr>
            <th>Location</th>
            <!-- Actions Column -->
            <th style="width: 50px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-location>
          <tr class="table-row">
            <td style="width: 100%">{{ location.url }}</td>

            <td style="width: 50px">
              <div class="delete-column-icon" (click)="$event.stopPropagation()">
                <img
                  *ngIf="editable"
                  src="assets/images/common/delete.svg"
                  class="delete-icon"
                  (click)="removeLocationClicked(location)"
                />
              </div>
            </td>
          </tr>
        </ng-template>
        <!-- When the table is empty ( data length 0) we get here -->
        <ng-template pTemplate="emptymessage">
          <app-no-data [tableNotFoundText]="tableNotFoundText" [tableNotFoundIcon]="tableNotFoundIcon"></app-no-data>
        </ng-template>
      </p-table>
    </div>
  </div>

  <app-form-footer
    *ngIf="editable"
    [changesWereDone]="changesWereDone"
    (resetChanges)="resetForm()"
    (saveChanges)="updatePolicyConfig()"
    (cancelSettings)="cancelSettings()"
  ></app-form-footer>

  <div *ngIf="isLoading$ | async" class="policy-sensitive-locations-spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
</div>
